

    if($('.product').length){
        function mhProducts(){
            $('.product').each(function(){
                if($(this).find('.widget-parameter-wrapper').length){
                    $(this).find('.ratings-wrapper').append($(this).find('.widget-parameter-wrapper'))
                }
                else{
                    $(this).find('.ratings-wrapper').append('<div class="widget-parameter-wrapper-empty"></div>')
                }

                if($(this).find('.flag-custom2').length){
                    $(this).find('a.image').append($(this).find('.flag-custom2'))
                }
              
                if($(this).find('.price-standard').length){
                    $(this).find('.flag-discount').html(function(){
                        return $(this).html().replace(' až ', '');
                    })
                    $(this).find('.price-final').addClass('haveSale');
                    $(this).find('.price-final strong').prepend($(this).find('.price-standard'));
                }
                
            })
        }
        $(document).ready(function(){
            mhProducts();
            loadJSON();
            displayColorData();
        })
        document.addEventListener('ShoptetDOMPageContentLoaded', function() {
            mhProducts();
            loadJSON();
            displayColorData();
        });
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
            mhProducts();
            loadJSON();
            displayColorData();
        });
    }
    
    
       // Funkce pro načtení JSON souboru a zpracování dat
    function loadJSON() {
        $.ajax({
          type: "GET",
          url: "/user/documents/variantImages/customColorsVariant.json?v=" + new Date().getUTCMinutes(),
          dataType: "json",
          success: function(data) {
            // Uložíme data do sessionStorage
            sessionStorage.setItem('colors', JSON.stringify(data));
          }
        });
      }
      
      // Funkce pro zobrazení dat o barvách na stránce
      function displayColorData() {
        setTimeout(function() {
          // Načtení uložených dat ze sessionStorage
          var storedColors = JSON.parse(sessionStorage.getItem('colors'));
      
          // Projdeme všechny produkty
          $(".product .widget-parameter-value a").each(function() {
            var title = $(this).attr("title").split(':')[1].trim();
      
            if (storedColors) {
              // Najdeme odpovídající barvu podle názvu
              var color = storedColors.find(function(item) {
                return item.color_name === title;
              });
      
              // Pokud existuje odpovídající barva
              if (color) {
                console.log(color)
                if (color.image_url) {
                  // Pokud má barva obrázek
                  $(this).addClass('haveImage');
                  $(this).attr('style', 'background-image:url(' + color.image_url.replace('uploads/', '/user/documents/variantImages/') + ');background-size: 100% auto;');
                } else if (color.hex_code) {
                  // Pokud má barva primární HEX kód
                  $(this).attr('style', 'background-color:' + color.hex_code + ';');
                }
      
                // Pokud má sekundární HEX kód (volitelné použití)
                if (color.secondary_hex_code) {
                  $(this).attr('data-secondary-color', color.secondary_hex_code);
                }
              }
            }
          });
        }, 250);
      }
      
    